import React from 'react';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

interface AlgoverseDeploymentCostAlertProps {
  isPremium?: boolean;
  variant?: 'alert' | 'text';
  className?: string;
}

const PREMIUM_COST = 20;
const STANDARD_COST = 10;

export const getDeploymentCost = (isPremium: boolean): number => (isPremium ? PREMIUM_COST : STANDARD_COST);

export const getDeploymentCostMessage = (isPremium: boolean): string => {
  const amount = getDeploymentCost(isPremium);
  return `Once deployed, this strategy will be charged at Rs ${amount} per day.`;
};

const AlgoverseDeploymentCostAlert: React.FC<AlgoverseDeploymentCostAlertProps> = ({
  isPremium = false,
  variant = 'text',
  className = '',
}) => {
  if (!ApplicationDomainUtility?.isAlgoverse) return null;

  const message = getDeploymentCostMessage(isPremium);

  if (variant === 'alert') {
    return (
      <div className={`alert alert-sm alert-info p-1 text-wrap text-center ${className}`}>{message}</div>
    );
  }

  return <span className={className}>{message}</span>;
};

export default AlgoverseDeploymentCostAlert;
